<template>
  <v-container>
    <div class="text-center mt-12">
      <v-icon
        large
        color="grey lighten-1"
      >
        mdi-map-marker-off-outline
      </v-icon>
      <h1 class="text-h6 mt-2">
        Page Not Found
      </h1>
      <p class="body-2 grey--text mt-1">
        The page you're looking for doesn't exist.
      </p>
      <v-sheet
        class="mx-auto mt-4 pa-3 text-left"
        max-width="400"
        outlined
        rounded
      >
        <div class="caption grey--text">
          <span class="font-weight-medium">Path:</span>
          <span class="ml-1">{{ $route.fullPath }}</span>
        </div>
      </v-sheet>
      <v-btn
        small
        class="mt-4"
        @click="() => $router.back()"
      >
        Go Back
      </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>
